<template>
  <div class="col-12">
    <div class="row">
      <div class="col-6">
        <router-link :to="'/services/' + 21">
          <div class="row">
            <div class="card mb-2 ml-2 mr-1">
              <img
                src="../../assets/images/service_3.png"
                alt="">
              <div class="card-body">
                <h5 class="card-title"> Xây nhà mới</h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-6">
        <router-link :to="'/services/' + 22">
          <div class="row">
            <div class="card mb-2 ml-1 mr-2">
              <img
                src="../../assets/images/service_1.png"
                alt="">
              <div class="card-body">
                <h5 class="card-title"> Giải lá số </h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-6">
        <router-link :to="'/services/' + 38">
          <div class="row">
            <div class="card mb-2 ml-2 mr-1">
              <img
                src="../../assets/images/service_4.jpg"
                alt="">
              <div class="card-body">
                <h5 class="card-title"> Kích tài lộc </h5>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ServiceHot",
    data () {
      return {
      }
    },
    methods: {}
  }
</script>

<style scoped>
  .card {
    border-radius: 10px;
    width: 100%;
  }
  .card img {
    max-height: 100px;
    height: 100px;
    border-bottom: 1px solid #e2e3e5;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .card-title {
    font-size: 14px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/ServiceHot.vue